const BomQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'product.sku',//SKU
            key:'sku',
            type:'select',
            allowClear:false,
            width:'200px',
            placeholder:'product.sku',
            options:[],
        },
        {
            // name:'product.inventoryCode', // 物料编码
            key:'inventory_code',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'product.inventoryCode',
            options:[],
        },
    ]
}

BomQuery.formField.forEach(item=>{
    BomQuery.formData[item.key] = ''
})

export {
    BomQuery
}